// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"MobileHeader_closeBtn__2zHrS","boxMain":"MobileHeader_boxMain__1eTXc","drawerBox":"MobileHeader_drawerBox__sCkgF"};